/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PatientPatientProviderType,
  PatientPatientProviderTypeFromJSON,
  PatientPatientProviderTypeToJSON,
} from "../models";

export interface GetPatientProviderTypesRequest {
  type: GetPatientProviderTypesTypeEnum;
}

/**
 *
 */
export class PatientProviderTypeApi extends runtime.BaseAPI {
  /**
   * Get patient provider type by type name
   */
  async getPatientProviderTypesRaw(
    requestParameters: GetPatientProviderTypesRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PatientPatientProviderType>> {
    if (requestParameters.type === null || requestParameters.type === undefined) {
      throw new runtime.RequiredError(
        "type",
        "Required parameter requestParameters.type was null or undefined when calling getPatientProviderTypes."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient-provider-types/{type}`.replace(
          `{${"type"}}`,
          encodeURIComponent(String(requestParameters.type))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PatientPatientProviderTypeFromJSON(jsonValue));
  }

  /**
   * Get patient provider type by type name
   */
  async getPatientProviderTypes(
    requestParameters: GetPatientProviderTypesRequest,
    initOverrides?: RequestInit
  ): Promise<PatientPatientProviderType> {
    return promiseRetry(
      (retry) =>
        this.getPatientProviderTypesRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetPatientProviderTypesTypeEnum {
  Email = "email",
  LineSundrug = "line-sundrug",
  OidcSatudora = "oidc-satudora",
  LineQol = "line-qol",
  LineTanpopo = "line-tanpopo",
  OidcMccm = "oidc-mccm",
  LineNicho = "line-nicho",
}
